import { call, put, takeLatest } from 'redux-saga/effects';
import uniqid from 'uniqid';

import { getProductScope } from '@discover-frontend/utils';
import {
  GET_REPORT_ERROR_REQUEST,
  GET_REPORT_ERROR_SUCCESS,
  GET_REPORT_ERROR_FAILURE,
  ADD_TOAST,
  REQUIRE_MISSING_ITEM_REQUEST,
  REQUIRE_MISSING_ITEM_SUCCESS,
  REQUIRE_MISSING_ITEM_FAILURE,
} from '../constants/action-types';
import { hideModal } from '../actions';

import * as api from '../services/engineApi';
import sagaFetch from './SagaFetch';

function* fetchReportError(action) {
  const { itemId, categoryId } = action;
  const { error } = yield call(api.fetchReportErrorApi, itemId, {
    category: categoryId,
    scope: getProductScope(),
  });

  if (!error) {
    return yield put({
      type: GET_REPORT_ERROR_SUCCESS,
    });
  }

  return yield put({
    type: GET_REPORT_ERROR_FAILURE,
    message: error,
  });
}

function* handleReportErrorSuccess() {
  const id = uniqid();
  yield put(hideModal());
  yield put({
    type: ADD_TOAST,
    id,
    toastProps: {
      status: 'success',
      message: 'REPORT_ITEM_ERROR',
    },
  });
}

function* fetchRequireMissingItem(action) {
  const { data } = action;
  data.scope = getProductScope();
  const { error } = yield sagaFetch(api.fetchRequireMissingItemApi, data);

  if (!error) {
    yield put({
      type: REQUIRE_MISSING_ITEM_SUCCESS,
    });

    const id = uniqid();
    yield put(hideModal());
    return yield put({
      type: ADD_TOAST,
      id,
      toastProps: {
        status: 'success',
        message: 'REQUIRE_MISSING_ITEM_SUCCESS',
      },
    });
  }

  return yield put({
    type: REQUIRE_MISSING_ITEM_FAILURE,
    message: error.message,
  });
}

export function* reportErrorActionWatcher() {
  yield takeLatest(GET_REPORT_ERROR_REQUEST, fetchReportError);
  yield takeLatest(GET_REPORT_ERROR_SUCCESS, handleReportErrorSuccess);
  yield takeLatest(REQUIRE_MISSING_ITEM_REQUEST, fetchRequireMissingItem);
}
